
// This file is auto-generated by `pnpm run --filter backend update_enums`
// Do not edit manually
/* eslint-disable camelcase */
export const COLORS = {
  biela: {
    label: 'biela',
    kooperativaV1: '101',
    komunalnaV1: '101',
    unionV2: 'BIELA',
  },
  cervena: {
    label: 'červená',
    kooperativaV1: '102',
    komunalnaV1: '102',
    unionV2: 'CERVENA',
  },
  cervena_metaliza: {
    label: 'červená metalíza',
    kooperativaV1: '103',
    komunalnaV1: '103',
    unionV2: 'CERVENA_METALIZA',
  },
  cervena_metaliza_pastelova: {
    label: 'červená metalíza pastelová',
    kooperativaV1: '104',
    komunalnaV1: '104',
    unionV2: 'CERVENA_METALIZA',
  },
  cervena_metaliza_svetla: {
    label: 'červená metalíza svetlá',
    kooperativaV1: '105',
    komunalnaV1: '105',
    unionV2: 'CERVENA_METALIZA',
  },
  cervena_metaliza_tmava: {
    label: 'červená metalíza tmavá',
    kooperativaV1: '106',
    komunalnaV1: '106',
    unionV2: 'CERVENA_METALIZA',
  },
  cervena_pastelova: {
    label: 'červená pastelová',
    kooperativaV1: '107',
    komunalnaV1: '107',
    unionV2: 'CERVENA',
  },
  cervena_svetla: {
    label: 'červená svetlá',
    kooperativaV1: '108',
    komunalnaV1: '108',
    unionV2: 'CERVENA',
  },
  cervena_tmava: {
    label: 'červená tmavá',
    kooperativaV1: '109',
    komunalnaV1: '109',
    unionV2: 'CERVENA',
  },
  cierna: {
    label: 'čierna',
    kooperativaV1: '110',
    komunalnaV1: '110',
    unionV2: 'CIERNA',
  },
  cierna_metaliza: {
    label: 'čierna metalíza',
    kooperativaV1: '111',
    komunalnaV1: '111',
    unionV2: 'CIERNA_METALIZA',
  },
  fialova: {
    label: 'fialová',
    kooperativaV1: '112',
    komunalnaV1: '112',
    unionV2: 'FIALOVA',
  },
  fialova_metaliza: {
    label: 'fialová metalíza',
    kooperativaV1: '113',
    komunalnaV1: '113',
    unionV2: 'FIALOVA_METALIZA',
  },
  fialova_metaliza_pastelova: {
    label: 'fialová metalíza pastelová',
    kooperativaV1: '114',
    komunalnaV1: '114',
    unionV2: 'FIALOVA_METALIZA',
  },
  fialova_metaliza_svetla: {
    label: 'fialová metalíza svetlá',
    kooperativaV1: '115',
    komunalnaV1: '115',
    unionV2: 'FIALOVA_METALIZA',
  },
  fialova_metaliza_tmava: {
    label: 'fialová metalíza tmavá',
    kooperativaV1: '116',
    komunalnaV1: '116',
    unionV2: 'FIALOVA_METALIZA',
  },
  fialova_pastelova: {
    label: 'fialová pastelová',
    kooperativaV1: '117',
    komunalnaV1: '117',
    unionV2: 'FIALOVA',
  },
  fialova_svetla: {
    label: 'fialová svetlá',
    kooperativaV1: '118',
    komunalnaV1: '118',
    unionV2: 'FIALOVA',
  },
  fialova_tmava: {
    label: 'fialová tmavá',
    kooperativaV1: '119',
    komunalnaV1: '119',
    unionV2: 'FIALOVA',
  },
  hneda: {
    label: 'hnedá',
    kooperativaV1: '120',
    komunalnaV1: '120',
    unionV2: 'HNEDA',
  },
  hneda_metaliza: {
    label: 'hnedá metalíza',
    kooperativaV1: '121',
    komunalnaV1: '121',
    unionV2: 'HNEDA_METALIZA',
  },
  hneda_metaliza_pastelova: {
    label: 'hnedá metalíza pastelová',
    kooperativaV1: '122',
    komunalnaV1: '122',
    unionV2: 'HNEDA_METALIZA',
  },
  hneda_metaliza_svetla: {
    label: 'hnedá metalíza svetlá',
    kooperativaV1: '123',
    komunalnaV1: '123',
    unionV2: 'HNEDA_METALIZA',
  },
  hneda_metaliza_tmava: {
    label: 'hnedá metalíza tmavá',
    kooperativaV1: '124',
    komunalnaV1: '124',
    unionV2: 'HNEDA_METALIZA',
  },
  hneda_pastelova: {
    label: 'hnedá pastelová',
    kooperativaV1: '125',
    komunalnaV1: '125',
    unionV2: 'HNEDA',
  },
  hneda_svetla: {
    label: 'hnedá svetlá',
    kooperativaV1: '126',
    komunalnaV1: '126',
    unionV2: 'HNEDA',
  },
  hneda_tmava: {
    label: 'hnedá tmavá',
    kooperativaV1: '127',
    komunalnaV1: '127',
    unionV2: 'HNEDA',
  },
  modra: {
    label: 'modrá',
    kooperativaV1: '128',
    komunalnaV1: '128',
    unionV2: 'MODRA',
  },
  modra_metaliza: {
    label: 'modrá metalíza',
    kooperativaV1: '129',
    komunalnaV1: '129',
    unionV2: 'MODRA_METALIZA',
  },
  modra_metaliza_pastelova: {
    label: 'modrá metalíza pastelová',
    kooperativaV1: '130',
    komunalnaV1: '130',
    unionV2: 'MODRA_METALIZA',
  },
  modra_metaliza_svetla: {
    label: 'modrá metalíza svetlá',
    kooperativaV1: '131',
    komunalnaV1: '131',
    unionV2: 'MODRA_METALIZA',
  },
  modra_metaliza_tmava: {
    label: 'modrá metalíza tmavá',
    kooperativaV1: '132',
    komunalnaV1: '132',
    unionV2: 'MODRA_METALIZA',
  },
  modra_pastelova: {
    label: 'modrá pastelová',
    kooperativaV1: '133',
    komunalnaV1: '133',
    unionV2: 'MODRA',
  },
  modra_svetla: {
    label: 'modrá svetlá',
    kooperativaV1: '134',
    komunalnaV1: '134',
    unionV2: 'MODRA',
  },
  modra_tmava: {
    label: 'modrá tmavá',
    kooperativaV1: '135',
    komunalnaV1: '135',
    unionV2: 'MODRA',
  },
  modrozelena: {
    label: 'modrozelená',
    kooperativaV1: '136',
    komunalnaV1: '136',
    unionV2: 'MODROZELENA',
  },
  modrozelena_metaliza: {
    label: 'modrozelená metalíza',
    kooperativaV1: '137',
    komunalnaV1: '137',
    unionV2: 'MODROZELENA_METALIZA',
  },
  modrozelena_metaliza_pastelova: {
    label: 'modrozelená metalíza pastelová',
    kooperativaV1: '138',
    komunalnaV1: '138',
    unionV2: 'MODROZELENA_METALIZA',
  },
  modrozelena_metaliza_svetla: {
    label: 'modrozelená metalíza svetlá',
    kooperativaV1: '139',
    komunalnaV1: '139',
    unionV2: 'MODROZELENA_METALIZA',
  },
  modrozelena_metaliza_tmava: {
    label: 'modrozelená metalíza tmavá',
    kooperativaV1: '140',
    komunalnaV1: '140',
    unionV2: 'MODROZELENA_METALIZA',
  },
  modrozelena_pastelova: {
    label: 'modrozelená pastelová',
    kooperativaV1: '141',
    komunalnaV1: '141',
    unionV2: 'MODROZELENA',
  },
  modrozelena_svetla: {
    label: 'modrozelená svetlá',
    kooperativaV1: '142',
    komunalnaV1: '142',
    unionV2: 'MODROZELENA',
  },
  modrozelena_tmava: {
    label: 'modrozelená tmavá',
    kooperativaV1: '143',
    komunalnaV1: '143',
    unionV2: 'MODROZELENA',
  },
  oranzova: {
    label: 'oranžová',
    kooperativaV1: '144',
    komunalnaV1: '144',
    unionV2: 'ORANZOVA',
  },
  oranzova_metaliza_zlata: {
    label: 'oranžová metalíza zlatá',
    kooperativaV1: '145',
    komunalnaV1: '145',
    unionV2: 'ORANZOVA_METALIZA',
  },
  oranzova_metaliza_pastelova: {
    label: 'oranžová metalíza pastelová',
    kooperativaV1: '146',
    komunalnaV1: '146',
    unionV2: 'ORANZOVA_METALIZA',
  },
  oranzova_metaliza_svetla: {
    label: 'oranžová metalíza svetlá',
    kooperativaV1: '147',
    komunalnaV1: '147',
    unionV2: 'ORANZOVA_METALIZA',
  },
  oranzova_metaliza_tmava: {
    label: 'oranžová metalíza tmavá',
    kooperativaV1: '148',
    komunalnaV1: '148',
    unionV2: 'ORANZOVA_METALIZA',
  },
  oranzova_pastelova: {
    label: 'oranžová pastelová',
    kooperativaV1: '149',
    komunalnaV1: '149',
    unionV2: 'ORANZOVA',
  },
  oranzova_svetla: {
    label: 'oranžová svetlá',
    kooperativaV1: '150',
    komunalnaV1: '150',
    unionV2: 'ORANZOVA',
  },
  oranzova_tmava: {
    label: 'oranžová tmavá',
    kooperativaV1: '151',
    komunalnaV1: '151',
    unionV2: 'ORANZOVA',
  },
  ruzova: {
    label: 'ružová',
    kooperativaV1: '152',
    komunalnaV1: '152',
    unionV2: 'RUZOVA',
  },
  seda: {
    label: 'sivá',
    kooperativaV1: '153',
    komunalnaV1: '153',
    unionV2: 'SEDA',
  },
  strieborna: {
    label: 'strieborná',
    kooperativaV1: '154',
    komunalnaV1: '154',
    unionV2: 'STRIEBORNA',
  },
  strieborna_metaliza_svetla: {
    label: 'strieborná metalíza svetlá',
    kooperativaV1: '154',
    komunalnaV1: '154',
    unionV2: 'STRIEBORNA_METALIZA',
  },
  strieborna_metaliza_pastelova: {
    label: 'strieborná metalíza pastelová',
    kooperativaV1: '155',
    komunalnaV1: '155',
    unionV2: 'STRIEBORNA_METALIZA',
  },
  seda_metaliza: {
    label: 'sivá metalíza',
    kooperativaV1: '156',
    komunalnaV1: '156',
    unionV2: 'SEDA_METALIZA',
  },
  seda_metaliza_tmava: {
    label: 'sivá metalíza tmavá',
    kooperativaV1: '157',
    komunalnaV1: '157',
    unionV2: 'SEDA_METALIZA',
  },
  seda_pastelova: {
    label: 'sivá pastelová',
    kooperativaV1: '158',
    komunalnaV1: '158',
    unionV2: 'SEDA',
  },
  seda_svetla: {
    label: 'sivá svetlá',
    kooperativaV1: '159',
    komunalnaV1: '159',
    unionV2: 'SEDA',
  },
  seda_tmava: {
    label: 'sivá tmavá',
    kooperativaV1: '160',
    komunalnaV1: '160',
    unionV2: 'SEDA',
  },
  sedomodra: {
    label: 'sedomodrá',
    kooperativaV1: '161',
    komunalnaV1: '161',
    unionV2: 'SEDOMODRA',
  },
  sedozelena: {
    label: 'sedozelená',
    kooperativaV1: '162',
    komunalnaV1: '162',
    unionV2: 'SEDOZELENA',
  },
  zelena: {
    label: 'zelená',
    kooperativaV1: '163',
    komunalnaV1: '163',
    unionV2: 'ZELENA',
  },
  zelena_metaliza: {
    label: 'zelená metalíza',
    kooperativaV1: '164',
    komunalnaV1: '164',
    unionV2: 'ZELENA_METALIZA',
  },
  zelena_metaliza_pastelova: {
    label: 'zelená metalíza pastelová',
    kooperativaV1: '165',
    komunalnaV1: '165',
    unionV2: 'ZELENA_METALIZA',
  },
  zelena_metaliza_svetla: {
    label: 'zelená metalíza svetlá',
    kooperativaV1: '166',
    komunalnaV1: '166',
    unionV2: 'ZELENA_METALIZA',
  },
  zelena_metaliza_tmava: {
    label: 'zelená metalíza tmavá',
    kooperativaV1: '167',
    komunalnaV1: '167',
    unionV2: 'ZELENA_METALIZA',
  },
  zelena_pastelova: {
    label: 'zelená pastelová',
    kooperativaV1: '168',
    komunalnaV1: '168',
    unionV2: 'ZELENA',
  },
  zelena_svetla: {
    label: 'zelená svetlá',
    kooperativaV1: '169',
    komunalnaV1: '169',
    unionV2: 'ZELENA',
  },
  zelena_tmava: {
    label: 'zelená tmavá',
    kooperativaV1: '170',
    komunalnaV1: '170',
    unionV2: 'ZELENA',
  },
  zelenozlta: {
    label: 'zelenožltá',
    kooperativaV1: '171',
    komunalnaV1: '171',
    unionV2: 'ZELENOZLTA',
  },
  zelenozlta_metaliza: {
    label: 'zelenožltá metalíza',
    kooperativaV1: '172',
    komunalnaV1: '172',
    unionV2: 'ZELENOZLTA_METALIZA',
  },
  zelenozlta_metaliza_pastelova: {
    label: 'zelenožltá metalíza pastelová',
    kooperativaV1: '173',
    komunalnaV1: '173',
    unionV2: 'ZELENOZLTA_METALIZA',
  },
  zelenozlta_metaliza_svetla: {
    label: 'zelenožltá metalíza svetlá',
    kooperativaV1: '174',
    komunalnaV1: '174',
    unionV2: 'ZELENOZLTA_METALIZA',
  },
  zelenozlta_metaliza_tmava: {
    label: 'zelenožltá metalíza tmavá',
    kooperativaV1: '175',
    komunalnaV1: '175',
    unionV2: 'ZELENOZLTA_METALIZA',
  },
  zelenozlta_pastelova: {
    label: 'zelenožltá pastelová',
    kooperativaV1: '176',
    komunalnaV1: '176',
    unionV2: 'ZELENOZLTA',
  },
  zelenozlta_svetla: {
    label: 'zelenožltá svetlá',
    kooperativaV1: '177',
    komunalnaV1: '177',
    unionV2: 'ZELENOZLTA',
  },
  zelenozlta_tmava: {
    label: 'zelenožltá tmavá',
    kooperativaV1: '178',
    komunalnaV1: '178',
    unionV2: 'ZELENOZLTA',
  },
  zlata: {
    label: 'zlatá',
    kooperativaV1: '180',
    komunalnaV1: '180',
    unionV2: 'ZLATA',
  },
  zlta: {
    label: 'žltá',
    kooperativaV1: '179',
    komunalnaV1: '179',
    unionV2: 'ZLTA',
  },
  zlta_metaliza_zlata: {
    label: 'žltá metalíza zlatá',
    kooperativaV1: '180',
    komunalnaV1: '180',
    unionV2: 'ZLTA_METALIZA',
  },
  zlta_metaliza_pastelova: {
    label: 'žltá metalíza pastelová',
    kooperativaV1: '181',
    komunalnaV1: '181',
    unionV2: 'ZLTA_METALIZA',
  },
  zlta_metaliza_svetla: {
    label: 'žltá metalíza svetlá',
    kooperativaV1: '182',
    komunalnaV1: '182',
    unionV2: 'ZLTA_METALIZA',
  },
  zlta_metaliza_tmava: {
    label: 'žltá metalíza tmavá',
    kooperativaV1: '183',
    komunalnaV1: '183',
    unionV2: 'ZLTA_METALIZA',
  },
  zlta_pastelova: {
    label: 'žltá pastelová',
    kooperativaV1: '184',
    komunalnaV1: '184',
    unionV2: 'ZLTA',
  },
  zlta_svetla: {
    label: 'žltá svetlá',
    kooperativaV1: '185',
    komunalnaV1: '185',
    unionV2: 'ZLTA',
  },
  zlta_tmava: {
    label: 'žltá tmavá',
    kooperativaV1: '186',
    komunalnaV1: '186',
    unionV2: 'ZLTA',
  },
  biela_metaliza: {
    label: 'biela metalíza',
    kooperativaV1: '187',
    komunalnaV1: '187',
    unionV2: 'BIELA_MATALIZA',
  },
  ruzova_metaliza: {
    label: 'ružová metalíza',
    kooperativaV1: '188',
    komunalnaV1: '188',
    unionV2: 'RUZOVA_METALIZA',
  },
  ruzova_metaliza_pastelova: {
    label: 'ružová pastelová metalíza',
    kooperativaV1: '189',
    komunalnaV1: '189',
    unionV2: 'RUZOVA_METALIZA',
  },
  ruzova_metaliza_svetla: {
    label: 'ružová svetlá metalíza',
    kooperativaV1: '190',
    komunalnaV1: '190',
    unionV2: 'RUZOVA_METALIZA',
  },
  ruzova_metaliza_tmava: {
    label: 'ružová tmavá metalíza',
    kooperativaV1: '191',
    komunalnaV1: '191',
    unionV2: 'RUZOVA_METALIZA',
  },
  ruzova_pastelova: {
    label: 'ružová pastelová',
    kooperativaV1: '192',
    komunalnaV1: '192',
    unionV2: 'RUZOVA',
  },
  ruzova_svetla: {
    label: 'ružová svetlá',
    kooperativaV1: '193',
    komunalnaV1: '193',
    unionV2: 'RUZOVA',
  },
  ruzova_tmava: {
    label: 'ružová tmavá',
    kooperativaV1: '194',
    komunalnaV1: '194',
    unionV2: 'RUZOVA',
  },
  sedozelena_metaliza: {
    label: 'šedo-zelená metalíza',
    kooperativaV1: '195',
    komunalnaV1: '195',
    unionV2: 'SEDOZELENA_METALIZA',
  },
} as const

export type Colors = typeof COLORS

export default COLORS
